import { HOME_SEARCH_QUERY, HOME_DISPLAY_RESULT, HOME_SEARCH_RECEIVE, HOME_USER_GEOLOCATION, HOME_FILTERED_STORES } from '../Actions/HomeSearch.action';

const DEFAULT_STATE = {
    homeStores: [],
    filteredStores: [],
    query: '',
    result: [],
    coords: null,
    showResult: false,
};

export const homeSearch = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case HOME_SEARCH_QUERY:
        case HOME_SEARCH_RECEIVE:
        case HOME_DISPLAY_RESULT:
        case HOME_USER_GEOLOCATION:
        case HOME_FILTERED_STORES:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
}